import { useState, useEffect } from "react";
import {
  VStack,
  Flex,
  Box,
  Text,
  NumberInput,
  NumberInputField,
  useColorModeValue,
  Button,
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { CustomPopover } from "../custom-popover";
import { TEXT_COLOR_LIGHT, TEXT_COLOR_DARK, baseFilterValues } from "../utils";

interface Props {
  value: [string, string];
  onApply: (newValue: [string, string]) => void;
}

export function EngagementCountFilter({ value, onApply }: Props) {
  const [minCount, setMinCount] = useState<string>("");
  const [maxCount, setMaxCount] = useState<string>("");
  const textColor = useColorModeValue(TEXT_COLOR_LIGHT, TEXT_COLOR_DARK);

  useEffect(() => {
    setMinCount(value[0]);
    setMaxCount(value[1]);
  }, [value]);

  let isActive = false;
  if (
    value[0] !== baseFilterValues.engagementCount[0] ||
    value[1] !== baseFilterValues.engagementCount[1]
  ) {
    isActive = true;
  }

  return (
    <CustomPopover
      property="Engagement count"
      value={`${value[0] || 0}-${value[1] || "unlimited"}`}
      isActive={isActive}
    >
      <VStack color={textColor} alignItems="flex-start" py="2">
        <Flex>
          <Box mr="2">
            <InfoOutlineIcon />
          </Box>
          <Box>
            <Text fontSize="xs">
              Number of likes and comments received over the last 30 days.
              Available only for some accounts.
            </Text>
          </Box>
        </Flex>
        <NumberInput
          size="sm"
          pt="2"
          value={minCount}
          onChange={(value) => setMinCount(value)}
        >
          <NumberInputField
            placeholder="Min. (default 0)"
            borderRadius="md"
            _placeholder={{ color: textColor }}
            color="initial"
          />
        </NumberInput>
        <NumberInput
          size="sm"
          value={maxCount}
          onChange={(value) => setMaxCount(value)}
        >
          <NumberInputField
            placeholder="Max. (default unlimited)"
            borderRadius="md"
            _placeholder={{ color: textColor }}
            color="initial"
          />
        </NumberInput>
        <Box pt="2" pl="1">
          <Button
            variant="primary"
            size="sm"
            onClick={() => onApply([minCount, maxCount])}
          >
            Apply
          </Button>
        </Box>
      </VStack>
    </CustomPopover>
  );
}
